import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// components
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
// helpers
import { addBreadcrumbSchema } from '../helpers';
// settings
import {
  massMediaList,
  timingProperties,
  aboutCompanyProps,
  previousBarometerList,
} from './settings';
// mui
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Grid2 from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import PollIcon from '@mui/icons-material/Poll';
import SpeedIcon from '@mui/icons-material/Speed';
import Typography from '@mui/material/Typography';
import LanguageIcon from '@mui/icons-material/Language';
import HandshakeIcon from '@mui/icons-material/Handshake';
import PsychologyIcon from '@mui/icons-material/Psychology';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';


import { BarometerPartners } from './partners/partners';

const iconMap = {
  speed: <SpeedIcon sx={{ mr: '8px', width: '24px', height: '24px' }} />,
  web: <LanguageIcon sx={{ mr: '8px', width: '24px', height: '24px' }} />,
  search: <PersonSearchIcon sx={{ mr: '8px', width: '24px', height: '24px' }} />,
  generator: <PsychologyIcon sx={{ mr: '8px', width: '24px', height: '24px' }} />,
};

const BarometerPage = () => {
  const { t } = useTranslation('global');

  useEffect(() => {
    const metaTitle = document.querySelector('title');
    const metaDescription = document.querySelector('meta[name="description"]');

    if (metaTitle) {
      metaTitle.textContent = 'Барометр ринку праці 2025 | GRC.UA';
    }

    if (metaDescription) {
      metaDescription.content = 'Барометр ринку праці — це системне дослідження, яке компанія GRC.UA проводить вже 14 років поспіль, поширюючи аналітичні матеріали серед бізнес-спільноти та ЗМІ. GRC.UA – українська компанія, що володіє кадровим порталом, єдиним в Україні створеним професіоналами з підбору та управління персоналом та поєднує онлайн-можливості порталу з пошуку роботи та офлайн-агенцію з підбору персоналу.'; // eslint-disable-line
    }

    window.scrollTo(0, 0);

    const breadcrumbs = [
      { name: 'Барометр ринку праці' },
    ];

    const script = addBreadcrumbSchema(breadcrumbs);

    return () => {
      if (script) document.head.removeChild(script);
    };
  }, [t]);

  return (
    <>
      <NavBar />
      <Box sx={{ mb: '40px' }}>
        <Box
          component='section'
          sx={{
            mb: '40px',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundImage: 'url(/Images/barometer/2025/banner-2025.jpg)',
          }}
        >
          <Box
            className='container'
            sx={{
              p: '72px 0',
              display: 'flex',
              textAlign: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography
              component='h1'
              sx={{
                mb: '24px',
                px: '12px',
                fontWeight: 500,
                color: '#FFFFFF',
                lineHeight: '110%',
                fontSize: { xs: '36px', md: '52px' },
              }}
            >
              Барометр ринку праці 2025.<br /> Прогнози на 2026
            </Typography>
            <Typography
              component='h6'
              className='container fw-normal'
              sx={{ color: '#A8AFC6', lineHeight: '120%' }}
            >
              <Link to='/' style={{ color: 'white' }}>
                {t('navHeaders.home')}
              </Link>
              {' / '}
              Барометр ринку праці
            </Typography>
          </Box>
        </Box>
        <Box component='section' sx={{ mb: '40px' }}>
          <Box className='container'>
            <Typography
              component='h2'
              sx={{
                mb: '32px',
                fontWeight: 500,
                color: '#D71920',
                textAlign: 'center',
                fontSize: { xs: '28px', md: '40px' },
              }}
            >
              Про проєкт «Барометр ринку праці»
            </Typography>
            <Grid2 container spacing={{ xs: 2, md: 3 }}>
              <Grid2 item size={{ xs: 12, lg: 7 }}>
                <Box
                  sx={{
                    height: '100%',
                    display: 'flex',
                    borderRadius: '20px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    border: '1px solid #CCCCCC',
                    p: { xs: '16px', md: '40px' },
                  }}
                >
                  <Typography
                    component='p'
                    sx={{
                      mb: 2,
                      fontWeight: 400,
                      lineHeight: '150%',
                      textAlign: 'justify',
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    <Typography
                      component='span'
                      sx={{ color: '#1D3176', fontWeight: 600, fontSize: { xs: '16px', md: '18px' } }}
                    >
                      Барометр ринку праці — це системне дослідження, яке компанія{' '}
                    </Typography>
                    <Typography
                      component='span'
                      sx={{ color: '#D32F2F', fontWeight: 700, fontSize: { xs: '16px', md: '18px' } }}
                    >
                      GRC.UA{' '}
                    </Typography>
                    <Typography
                      component='span'
                      sx={{ color: '#1D3176', fontWeight: 600, fontSize: { xs: '16px', md: '18px' } }}
                    >
                      проводить вже 14 років поспіль{', '}
                    </Typography>
                    поширюючи аналітичні матеріали серед бізнес-спільноти та ЗМІ
                  </Typography>
                  <Typography
                    component='p'
                    sx={{
                      mb: 2,
                      fontWeight: 400,
                      lineHeight: '150%',
                      textAlign: 'justify',
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Барометр дозволяє виявити ключові виклики, тенденції та очікування на ринку:
                  </Typography>
                  <List
                    sx={{
                      m: 0,
                      pb: 0,
                      pt: 0,
                      pl: '24px',
                      fontSize: { xs: '16px', md: '18px' },
                      '& .MuiListItem-root': {
                        m: 0,
                        pb: 0,
                        pt: 0,
                        mb: '12px',
                        pl: '32px',
                        position: 'relative',
                      },
                      '& .MuiListItem-root::before': {
                        left: 0,
                        top: '14px',
                        content: '""',
                        width: '16px',
                        height: '16px',
                        borderRadius: '2px',
                        position: 'absolute',
                        background: '#1D3176',
                        display: 'inline-block',
                        transform: 'translateY(-50%) rotate(45deg)',
                      },
                    }}
                  >
                    <ListItem>як змінюється попит на професії та навички</ListItem>
                    <ListItem>які умови праці є пріоритетними для кандидатів</ListItem>
                    <ListItem>як компанії адаптуються до нових економічних реалій</ListItem>
                    <ListItem>які стратегії найму та мотивації будуть ефективними у найближчому майбутньому</ListItem>
                  </List>
                </Box>
              </Grid2>
              <Grid2 item size={{ xs: 12, lg: 5 }}>
                <Box sx={{ height: '100%', borderRadius: '20px', display: 'flex', alignItems: 'center' }}>
                  <img
                    loading='lazy'
                    alt='about-project-image'
                    style={{ width: '100%', borderRadius: '20px' }}
                    src='/Images/barometer/2025/about-project-image.jpg'
                  />
                </Box>
              </Grid2>
              <Grid2 item size={{ xs: 12, lg: 5 }}>
                <Box
                  sx={{
                    height: '100%',
                    display: 'flex',
                    borderRadius: '20px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    border: '1px solid #CCCCCC',
                    p: { xs: '16px', md: '40px' },
                  }}
                >
                  <Typography
                    component='p'
                    sx={{
                      mb: 2,
                      fontWeight: 400,
                      lineHeight: '150%',
                      textAlign: 'justify',
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    <Typography
                      component='span'
                      sx={{ color: '#1D3176', fontWeight: 600, fontSize: { xs: '16px', md: '18px' } }}
                    >
                      Опитування охоплює роботодавців із 15+ галузей та працівників/шукачів різного віку, кваліфікацій і кар’єрного досвіду{' '}
                    </Typography>
                    по всій території України (крім тимчасово окупованих)
                  </Typography>
                  <Typography
                    component='p'
                    sx={{
                      fontWeight: 400,
                      lineHeight: '150%',
                      textAlign: 'justify',
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Щороку презентація результатів Барометру збирає лідерів думок, представників державних інституцій і бізнесу,{' '}
                    HR-експертів України та представників ЗМІ для обговорення найактуальніших питань ринку праці та формування прогнозів на наступний рік
                  </Typography>
                </Box>
              </Grid2>
              <Grid2 container size={{ xs: 12, lg: 7 }} spacing={{ xs: 2, md: 3 }}>
                <Grid2 size={12}>
                  <Box
                    sx={{
                      height: '100%',
                      display: 'flex',
                      borderRadius: '20px',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      border: '1px solid #CCCCCC',
                      p: { xs: '16px', md: '30px' },
                    }}
                  >
                    <Typography
                      component='p'
                      sx={{
                        fontWeight: 400,
                        lineHeight: '150%',
                        textAlign: 'justify',
                        fontSize: { xs: '16px', md: '18px' },
                      }}
                    >
                      Результати дослідження стають надійним орієнтиром для HR-спеціалістів, управлінців, медіа, аналітиків і всіх,
                      хто працює з людьми та розвиває команди.{' '}
                      <Typography
                        component='span'
                        sx={{ color: '#1D3176', fontWeight: 600, fontSize: { xs: '16px', md: '18px' } }}
                      >
                        У 2024 році до дослідження долучилися 2700 компаній і 6600 працівників/шукачів
                      </Typography>
                    </Typography>
                  </Box>
                </Grid2>
                <Grid2 size={12}>
                  <Box
                    sx={{
                      height: '100%',
                      display: 'flex',
                      borderRadius: '20px',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      backgroundColor: '#0D2051',
                      border: '1px solid #0D2051',
                      p: { xs: '16px', md: '30px' },
                    }}
                  >
                    <Typography
                      component='p'
                      sx={{
                        mb: '12px',
                        fontWeight: 400,
                        color: '#FFFFFF',
                        lineHeight: '150%',
                        fontSize: { xs: '16px', md: '18px' },
                      }}
                    >
                      <CalendarMonthIcon sx={{ mr: '12px', width: '28px', height: '28px', color: '#BAD3FA' }} />
                      Цьогорічна презентація результатів відбудеться{' '}
                      <Typography
                        component='span'
                        sx={{ color: '#9FC5FF', fontWeight: 600, fontSize: { xs: '16px', md: '18px' } }}
                      >
                        17 грудня 2025 року
                      </Typography>
                    </Typography>
                    <Typography
                      component='p'
                      sx={{
                        mb: '12px',
                        fontWeight: 400,
                        color: '#FFFFFF',
                        lineHeight: '150%',
                        fontSize: { xs: '16px', md: '18px' },
                      }}
                    >
                      <EmojiPeopleIcon sx={{ mr: '12px', width: '28px', height: '28px', color: '#BAD3FA' }} />
                      Організатор дослідження -{' '}
                      <Typography
                        component='span'
                        sx={{ color: '#9FC5FF', fontWeight: 600, fontSize: { xs: '16px', md: '18px' } }}
                      >
                        GRC.UA
                      </Typography>
                    </Typography>
                    <Typography
                      component='p'
                      sx={{
                        fontWeight: 400,
                        color: '#FFFFFF',
                        lineHeight: '150%',
                        fontSize: { xs: '16px', md: '18px' },
                      }}
                    >
                      <PsychologyIcon sx={{ mr: '12px', width: '28px', height: '28px', color: '#BAD3FA' }} />
                      Методологія дослідження -{' '}
                      <Typography
                        component='span'
                        sx={{ color: '#9FC5FF', fontWeight: 600, fontSize: { xs: '16px', md: '18px' } }}
                      >
                        GRC.UA
                      </Typography>
                    </Typography>
                  </Box>
                </Grid2>
              </Grid2>
            </Grid2>
          </Box>
        </Box>
        <Box
          component='section'
          sx={{
            mb: '40px',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundImage: 'url(/Images/barometer/2025/timing-bg.png)',
          }}
        >
          <Box
            className='container'
            sx={{
              p: '40px 12px',
              display: 'flex',
              textAlign: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography
              component='h2'
              sx={{
                mb: '32px',
                fontWeight: 500,
                color: '#D71920',
                textAlign: 'center',
                fontSize: { xs: '28px', md: '40px' },
              }}
            >
              Таймінг проєкту «Барометр ринку праці»
            </Typography>
            <Box sx={{ mx: 'auto', gap: { xs: '12px', lg: '50px' }, height: '812px', display: 'flex' }}>
              <Box
                sx={{
                  backgroundSize: 'contain',
                  backgroundPosition: 'right',
                  backgroundRepeat: 'no-repeat',
                  width: { xs: '52px', lg: '380px' },
                  backgroundImage: 'url(/Images/barometer/2025/timing-scale.png)',
                }}
              >
                <Typography
                  component='p'
                  sx={{
                    mt: '62px',
                    textAlign: 'left',
                    display: { xs: 'none', lg: 'block' },
                    fontSize: { xs: '20px', md: '24px' },
                  }}
                >
                  Липень – Вересень 2025
                </Typography>
                <Typography
                  component='p'
                  sx={{
                    mt: '244px',
                    textAlign: 'left',
                    display: { xs: 'none', lg: 'block' },
                    fontSize: { xs: '20px', md: '24px' },
                  }}
                >
                  Вересень – Листопад 2025
                </Typography>
                <Typography
                  component='p'
                  sx={{
                    mt: '212px',
                    textAlign: 'left',
                    display: { xs: 'none', lg: 'block' },
                    fontSize: { xs: '20px', md: '24px' },
                  }}
                >
                  17 грудня 2025
                </Typography>
              </Box>
              <Box
                sx={{
                  gap: '16px',
                  display: 'flex',
                  maxHeight: '754px',
                  flexDirection: 'column',
                  my: { xs: 0, lg: 'auto' },
                  justifyContent: 'space-between',
                }}
              >
                {
                  timingProperties.map(({ title, period, planPoints }) => (
                    <Box
                      key={title}
                      sx={{
                        display: 'flex',
                        borderRadius: '20px',
                        flexDirection: 'column',
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #CCCCCC',
                        p: { xs: '18px', lg: '36px' },
                        maxWidth: { xs: '300px', lg: '770px' },
                      }}
                    >
                      <Typography
                        component='h3'
                        sx={{
                          fontWeight: 500,
                          textAlign: 'left',
                          mb: { xs: '8px', lg: '20px' },
                          fontSize: { xs: '18px', lg: '26px' },
                        }}
                      >
                        {title}
                        <Typography component='span' sx={{ color: '#D71920', display: { xs: 'inline-block', lg: 'none' } }}>
                          {' '}{period}
                        </Typography>
                      </Typography>
                      <List
                        sx={{
                          m: 0,
                          pb: 0,
                          pt: 0,
                          pl: { xs: '0px', lg: '24px' },
                          fontSize: { xs: '16px', lg: '18px' },
                          '& .MuiListItem-root': {
                            m: 0,
                            pb: 0,
                            pt: 0,
                            mb: '6px',
                            pl: '32px',
                            position: 'relative',
                          },
                          '& .MuiListItem-root::before': {
                            left: 0,
                            top: '14px',
                            content: '""',
                            width: '16px',
                            height: '16px',
                            borderRadius: '2px',
                            position: 'absolute',
                            background: '#1D3176',
                            display: 'inline-block',
                            transform: 'translateY(-50%) rotate(45deg)',
                          },
                        }}
                      >
                        {
                          planPoints.map(point => (
                            <ListItem key={point}>{point}</ListItem>
                          ))
                        }
                      </List>
                    </Box>
                  ))
                }
              </Box>
            </Box>
          </Box>
        </Box>
        <Box component='section' sx={{ mb: '40px' }}>
          <Box className='container' sx={{ px: '12px' }}>
            <Typography
              component='h2'
              sx={{
                mb: '32px',
                fontWeight: 500,
                color: '#D71920',
                textAlign: 'center',
                fontSize: { xs: '28px', md: '40px' },
              }}
            >
              Долучайтесь до створення Барометру ринку праці 2025
            </Typography>
            <Grid2 container spacing={{ xs: 2, md: 3 }}>
              <Grid2 item size={{ xs: 12, md: 6 }} sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box
                  sx={{
                    height: '100%',
                    display: 'flex',
                    borderRadius: '20px',
                    flexDirection: 'column',
                    border: '1px solid #CCCCCC',
                    p: { xs: '16px', md: '40px' },
                  }}
                >
                  <Typography
                    component='h3'
                    sx={{
                      fontWeight: 500,
                      mb: { xs: '12px', lg: '20px' },
                      fontSize: { xs: '18px', lg: '26px' },
                    }}
                  >
                    Пройдіть опитування
                  </Typography>
                  <Typography
                    component='h4'
                    sx={{
                      fontWeight: 500,
                      color: '#D71920',
                      mb: { xs: '12px', lg: '20px' },
                      fontSize: { xs: '16px', lg: '20px' },
                    }}
                  >
                    Ваша думка важлива!
                  </Typography>
                  <Typography
                    component='p'
                    sx={{
                      fontWeight: 400,
                      lineHeight: '150%',
                      textAlign: 'justify',
                      mb: { xs: '12px', lg: '20px' },
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Щоб сформувати обʼєктивну аналітику ринку праці, ми запрошуємо працівників/шукачів і роботодавців поділитися своїм досвідом,
                    очікуваннями та викликами
                  </Typography>
                  <Typography
                    component='p'
                    sx={{
                      fontWeight: 400,
                      lineHeight: '150%',
                      textAlign: 'justify',
                      mb: { xs: '12px', lg: '20px' },
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Чим більше відповідей — тим точніше ми зможемо:
                  </Typography>
                  <List
                    sx={{
                      m: 0,
                      pb: 0,
                      pt: 0,
                      pl: '24px',
                      mb: { xs: '12px', lg: '20px' },
                      fontSize: { xs: '16px', md: '18px' },
                      '& .MuiListItem-root': {
                        m: 0,
                        pb: 0,
                        pt: 0,
                        mb: '12px',
                        pl: '32px',
                        position: 'relative',
                      },
                      '& .MuiListItem-root::before': {
                        left: 0,
                        top: '14px',
                        content: '""',
                        width: '16px',
                        height: '16px',
                        borderRadius: '2px',
                        position: 'absolute',
                        background: '#1D3176',
                        display: 'inline-block',
                        transform: 'translateY(-50%) rotate(45deg)',
                      },
                    }}
                  >
                    <ListItem>зібрати реальні тренди</ListItem>
                    <ListItem>порівняти думки обох сторін ринку</ListItem>
                    <ListItem>побудувати прогнози на 2026 рік</ListItem>
                  </List>
                  <Typography
                    component='p'
                    sx={{
                      fontWeight: 400,
                      lineHeight: '150%',
                      textAlign: 'justify',
                      mb: { xs: '24px', lg: '32px' },
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Пройти опитування — це ваш внесок у формування прозорого ринку праці
                  </Typography>
                  <Button
                    component={Link}
                    to='/barometer-2025-questionnaire'
                    sx={{
                      mt: 'auto',
                      p: '8px 24px',
                      color: '#FFFFFF',
                      width: 'fit-content',
                      textTransform: 'none',
                      backgroundColor: '#EB3036',
                      fontSize: { xs: '14px', md: '20px' },
                    }}
                  >
                    <PollIcon sx={{ mr: '8px', width: '20px', height: '20px', color: '#FFFFFF' }} />
                    Пройти опитування
                  </Button>
                </Box>
              </Grid2>
              <Grid2 item size={{ xs: 12, md: 6 }} sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box
                  sx={{
                    height: '100%',
                    display: 'flex',
                    borderRadius: '20px',
                    flexDirection: 'column',
                    border: '1px solid #CCCCCC',
                    p: { xs: '16px', md: '40px' },
                  }}
                >
                  <Typography
                    component='h3'
                    sx={{
                      fontWeight: 500,
                      mb: { xs: '12px', lg: '20px' },
                      fontSize: { xs: '18px', lg: '26px' },
                    }}
                  >
                    Станьте партнером дослідження
                  </Typography>
                  <Typography
                    component='h4'
                    sx={{
                      fontWeight: 500,
                      color: '#D71920',
                      mb: { xs: '12px', lg: '20px' },
                      fontSize: { xs: '16px', lg: '20px' },
                    }}
                  >
                    Разом формуємо ринок праці!
                  </Typography>
                  <Typography
                    component='p'
                    sx={{
                      fontWeight: 400,
                      lineHeight: '150%',
                      textAlign: 'justify',
                      mb: { xs: '12px', lg: '20px' },
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Партнерство в Барометрі — це поєднання соціального впливу та вигідної експертної присутності
                  </Typography>
                  <Typography
                    component='p'
                    sx={{
                      fontWeight: 400,
                      lineHeight: '150%',
                      textAlign: 'justify',
                      mb: { xs: '12px', lg: '20px' },
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Ваша компанія отримає:
                  </Typography>
                  <List
                    sx={{
                      m: 0,
                      pb: 0,
                      pt: 0,
                      pl: '24px',
                      mb: { xs: '12px', lg: '20px' },
                      fontSize: { xs: '16px', md: '18px' },
                      '& .MuiListItem-root': {
                        m: 0,
                        pb: 0,
                        pt: 0,
                        mb: '12px',
                        pl: '32px',
                        position: 'relative',
                      },
                      '& .MuiListItem-root::before': {
                        left: 0,
                        top: '14px',
                        content: '""',
                        width: '16px',
                        height: '16px',
                        borderRadius: '2px',
                        position: 'absolute',
                        background: '#1D3176',
                        display: 'inline-block',
                        transform: 'translateY(-50%) rotate(45deg)',
                      },
                    }}
                  >
                    <ListItem>візуальну присутність у звіті, на сайті, у розсилках та трансляції</ListItem>
                    <ListItem>можливість виступити з коментарем як лідер галузі</ListItem>
                    <ListItem>прямий контакт з аудиторією шукачів</ListItem>
                    <ListItem>включення до комунікацій у ЗМІ</ListItem>
                  </List>
                  <Typography
                    component='p'
                    sx={{
                      fontWeight: 400,
                      lineHeight: '150%',
                      textAlign: 'justify',
                      mb: { xs: '24px', lg: '32px' },
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Ознайомтесь з можливостями партнерських пакетів
                    <Button
                      href='https://docs.google.com/spreadsheets/d/1WtUyEw5ro05nVsOwSnI8C-xGXsxIXY9i/edit?gid=1309853143#gid=1309853143'
                      target='_blank'
                      rel='noreferrer nofollow noopener'
                      sx={{
                        m: 0,
                        p: '0 8px',
                        color: '#1D3176',
                        minWidth: 'fit-content',
                        textDecoration: 'underline',
                      }}
                    >
                      тут
                    </Button>
                    та оберіть той, що найкраще відповідає вашим цілям
                  </Typography>
                  <Button
                    component={Link}
                    to='/contact'
                    sx={{
                      mt: 'auto',
                      p: '8px 24px',
                      color: '#FFFFFF',
                      width: 'fit-content',
                      textTransform: 'none',
                      backgroundColor: '#EB3036',
                      fontSize: { xs: '14px', md: '20px' },
                    }}
                  >
                    <HandshakeIcon sx={{ mr: '8px', width: '20px', height: '20px', color: '#FFFFFF' }} />
                    Залишити заявку на партнерство
                  </Button>
                </Box>
              </Grid2>
            </Grid2>
          </Box>
        </Box>

              <BarometerPartners/>
      
        <Box component='section' sx={{ mb: '40px' }}>
          <Box className='container' sx={{ px: '12px' }}>
            <Typography
              component='h2'
              sx={{
                mb: '32px',
                fontWeight: 500,
                color: '#D71920',
                textAlign: 'center',
                fontSize: { xs: '28px', md: '40px' },
              }}
            >
              ЗМІ про «Барометр ринку праці»
            </Typography>
            <Grid2 container spacing={{ xs: 2, md: 3 }}>
              <Grid2 item size={{ xs: 12, sm: 6, lg: 4 }} sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box
                  sx={{
                    height: '100%',
                    display: 'flex',
                    borderRadius: '20px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    backgroundColor: '#0D2051',
                    border: '1px solid #0D2051',
                    p: { xs: '16px', md: '36px' },
                  }}
                >
                  <Typography
                    component='p'
                    sx={{
                      mb: '12px',
                      fontWeight: 400,
                      color: '#FFFFFF',
                      lineHeight: '150%',
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Щороку{' '}
                    <Typography
                      component='span'
                      sx={{ color: '#9FC5FF', fontWeight: 600, fontSize: { xs: '16px', md: '18px' } }}
                    >
                      результати дослідження стають основою для аналітичних публікацій{' '}
                    </Typography>
                    у провідних бізнес-виданнях України.
                  </Typography>
                  <Typography
                    component='p'
                    sx={{
                      fontWeight: 400,
                      color: '#FFFFFF',
                      lineHeight: '150%',
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Серед них:
                  </Typography>
                </Box>
              </Grid2>
              {
                massMediaList.map(({ link, logo, title, descr }) => (
                  <Grid2 item key={title} size={{ xs: 12, sm: 6, lg: 4 }} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box
                      sx={{
                        height: '100%',
                        display: 'flex',
                        borderRadius: '20px',
                        flexDirection: 'column',
                        border: '1px solid #CCCCCC',
                        p: { xs: '16px', md: '36px' },
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box sx={{ mb: '16px', height: '78px' }}>
                        <img
                          src={logo}
                          height='78px'
                          loading='lazy'
                          alt='about-project-image'
                        />
                      </Box>
                      <Typography
                        component='p'
                        sx={{
                          mb: '16px',
                          fontWeight: 400,
                          lineHeight: '150%',
                          fontSize: { xs: '16px', md: '18px' },
                        }}
                      >
                        <Typography
                          component='span'
                          sx={{ color: '#1D3176', fontWeight: 600, fontSize: { xs: '16px', md: '18px' } }}
                        >
                          {title}{' '}
                        </Typography>
                        {descr}
                      </Typography>
                      <Button
                        href={link}
                        target='_blank'
                        rel='noreferrer nofollow noopener'
                        sx={{
                          m: 0,
                          p: 0,
                          fontWeight: 400,
                          lineHeight: '150%',
                          width: 'fit-content',
                          textTransform: 'none',
                          fontSize: { xs: '16px', md: '18px' },
                        }}
                      >
                        Переглянути статтю
                      </Button>
                    </Box>
                  </Grid2>
                ))
              }
              {/* <Grid2 item size={{ xs: 12, md: 6 }} sx={{ mx: 'auto', display: 'flex', flexDirection: 'column' }}>
                <Box
                  sx={{
                    height: '100%',
                    display: 'flex',
                    borderRadius: '20px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    backgroundColor: '#0D2051',
                    border: '1px solid #0D2051',
                    p: { xs: '16px', md: '36px' },
                  }}
                >
                  <Typography
                    component='p'
                    sx={{
                      mb: '12px',
                      fontWeight: 400,
                      color: '#FFFFFF',
                      lineHeight: '150%',
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Крім того,{' '}
                    <Typography
                      component='span'
                      sx={{ color: '#9FC5FF', fontWeight: 600, fontSize: { xs: '16px', md: '18px' } }}
                    >
                      результати «Барометру» активно обговорюються під час експертних панельних дискусій,{' '}
                    </Typography>
                    які транслюються онлайн та привертають увагу тисяч HR-спеціалістів та бізнес-лідерів
                  </Typography>
                </Box>
              </Grid2> */}
            </Grid2>
          </Box>
        </Box>
        <Box component='section' sx={{ mb: '40px' }}>
          <Box className='container' sx={{ px: '12px' }}>
            <Typography
              component='h2'
              sx={{
                mb: '32px',
                fontWeight: 500,
                color: '#D71920',
                textAlign: 'center',
                fontSize: { xs: '28px', md: '40px' },
              }}
            >
              Дослідження попередніх років
            </Typography>
            <Typography
              component='p'
              sx={{
                mx: 'auto',
                mb: '24px',
                fontWeight: 400,
                maxWidth: '630px',
                lineHeight: '150%',
                textAlign: 'center',
                fontSize: { xs: '16px', md: '18px' },
              }}
            >
              Ми щорічно збираємо найактуальнішу інформацію про стан ринку праці. Ознайомтесь із результатами минулих досліджень
            </Typography>
            <Grid2 container spacing={{ xs: 2, md: 3 }}>
              {
                previousBarometerList.map(({ link, title, videoLink }) => (
                  <Grid2 item key={link} size={{ xs: 12, md: 6 }} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box
                      sx={{
                        mb: '20px',
                        overflow: 'hidden',
                        borderRadius: '20px',
                        height: { xs: '194px', sm: '346px' },
                      }}
                    >
                      <iframe
                        width='100%'
                        height='100%'
                        allowFullScreen
                        src={videoLink}
                        title='YouTube video player'
                        style={{ borderRadius: '20px' }}
                        referrerPolicy='strict-origin-when-cross-origin'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                      ></iframe>
                    </Box>
                    <Button
                      href={link}
                      target='_blank'
                      rel='noreferrer nofollow noopener'
                      sx={{
                        display: 'flex',
                        textAlign: 'left',
                        borderRadius: '20px',
                        textTransform: 'none',
                        flexDirection: 'column',
                      }}
                    >
                      <Box sx={{ py: '8px', pl: '20px', mr: 'auto', width: 'fit-content', borderLeft: '2px solid #1D3176' }}>
                        <Typography sx={{ mb: '4px', fontWeight: 500, color: '#1D3176', fontSize: { xs: '16px', md: '18px' } }}>{link}</Typography>
                        <Typography sx={{ fontWeight: 500, color: '#D71920', fontSize: { xs: '18px', md: '20px' } }}>{title}</Typography>
                      </Box>
                    </Button>
                  </Grid2>
                ))
              }
            </Grid2>
          </Box>
        </Box>
        <Box
          component='section'
          sx={{
            mb: '80px',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: { xs: 'auto', lg: '706px' },
            backgroundImage: 'url(/Images/barometer/2025/partners-bg.png)',
          }}
        >
          <Box
            className='container'
            sx={{
              p: '40px 12px',
              display: 'flex',
              color: '#FFFFFF',
              flexDirection: 'column',
              height: { xs: 'auto', lg: '706px' },
            }}
          >
            <Typography
              component='h2'
              sx={{
                mb: '32px',
                fontWeight: 500,
                color: '#FFFFFF',
                lineHeight: '110%',
                textAlign: 'center',
                fontSize: { xs: '28px', md: '40px' },
              }}
            >
              Про компанію GRC.UA
            </Typography>
            <Box
              sx={{
                height: '550px',
                position: 'relative',
                display: { xs: 'none', lg: 'block' },
              }}
            >
              <Box sx={{ top: '50%', left: '50%', width: '390px', height: '396px', position: 'absolute', transform: 'translate(-50%, -50%)' }}>
                <img
                  loading='lazy'
                  alt='about-company-image'
                  src='/Images/barometer/2025/about-company.png'
                />
              </Box>
              {
                aboutCompanyProps.map(({ top, icon, left, title, descr }) => (
                  <Box
                    key={title}
                    sx={{
                      top: top,
                      left: left,
                      width: '424px',
                      display: 'flex',
                      borderRadius: '20px',
                      position: 'absolute',
                      flexDirection: 'column',
                      border: '1px solid #657CA6',
                      backgroundColor: '#2B3E6D80',
                      p: { xs: '16px', md: '24px 36px' },
                    }}
                  >
                    <Typography
                      component='h3'
                      sx={{
                        mb: '12px',
                        display: 'flex',
                        fontWeight: 500,
                        color: '#9FC5FF',
                        lineHeight: '150%',
                        alignItems: 'center',
                        fontSize: { xs: '20px', md: '22px' },
                      }}
                    >
                      {iconMap[icon]}
                      {title}
                    </Typography>
                    <Typography
                      component='p'
                      sx={{
                        fontWeight: 400,
                        lineHeight: '150%',
                        textAlign: 'justify',
                        fontSize: { xs: '16px', md: '18px' },
                      }}
                    >
                      {descr}
                    </Typography>
                  </Box>
                ))
              }
            </Box>
            <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
              <Box sx={{ mb: '16px', mx: 'auto', width: '68px', height: '68px' }}>
                <img
                  loading='lazy'
                  alt='about-company-image'
                  src='/Images/barometer/2025/grc-logo.png'
                />
              </Box>
              <Typography
                component='p'
                sx={{
                  mb: '12px',
                  fontWeight: 400,
                  color: '#FFFFFF',
                  lineHeight: '150%',
                  textAlign: 'center',
                  fontSize: { xs: '20px', md: '18px' },
                }}
              >
                <Typography component='span' sx={{ color: '#9FC5FF', fontSize: { xs: '20px', md: '18px' } }}>
                  GRC.UA{' '}
                </Typography>
                – екосистема для роботодавців та кандидатів
              </Typography>
              <Grid2 container spacing={{ xs: 2, md: 3 }}>
                {
                  aboutCompanyProps.map(({ icon, title, descr }) => (
                    <Grid2
                      item
                      key={title}
                      size={{ xs: 12, sm: 6, lg: 4 }}
                      sx={{
                        display: 'flex',
                        borderRadius: '20px',
                        flexDirection: 'column',
                        border: '1px solid #657CA6',
                        backgroundColor: '#2B3E6D80',
                        p: { xs: '16px', md: '24px 36px' },
                      }}
                    >
                      <Typography
                        component='h3'
                        sx={{
                          mb: '12px',
                          display: 'flex',
                          fontWeight: 500,
                          color: '#9FC5FF',
                          lineHeight: '150%',
                          alignItems: 'center',
                          fontSize: { xs: '20px', md: '24px' },
                        }}
                      >
                        {iconMap[icon]}
                        {title}
                      </Typography>
                      <Typography
                        component='p'
                        sx={{
                          fontWeight: 400,
                          lineHeight: '150%',
                          textAlign: 'justify',
                          fontSize: { xs: '16px', md: '18px' },
                        }}
                      >
                        {descr}
                      </Typography>
                    </Grid2>
                  ))
                }
              </Grid2>
            </Box>
          </Box>
        </Box>
        <Box component='section' sx={{ mb: '80px' }}>
          <Box className='container' sx={{ px: '12px', textAlign: 'center' }}>
            <Typography
              component='h2'
              sx={{
                mb: '32px',
                fontWeight: 500,
                color: '#D71920',
                textAlign: 'center',
                fontSize: { xs: '28px', md: '40px' },
              }}
            >
              Контакти для ЗМІ та партнерів
            </Typography>
            <Typography
              component='p'
              sx={{
                mx: 'auto',
                mb: '24px',
                fontWeight: 400,
                maxWidth: '630px',
                lineHeight: '150%',
                textAlign: 'center',
                fontSize: { xs: '16px', md: '18px' },
              }}
            >
              Зв’яжіться з нами з питань партнерства та медіа-взаємодії:
            </Typography>
            <Box
              sx={{
                mb: '32px',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: { xs: '16px', lg: '32px' },
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              <Box sx={{ gap: '16px', display: 'flex', alignItems: 'center' }}>
                <EmailOutlinedIcon sx={{ width: '36px', height: '36px', color: '#1D3176' }} />
                <Box>
                  <Typography
                    component='p'
                    sx={{
                      fontWeight: 500,
                      color: '#333333',
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Електронна пошта:
                  </Typography>
                  <a href='mailto:info@grc.ua'>
                    info@grc.ua
                  </a>
                </Box>
              </Box>
              <Box sx={{ gap: '16px', display: 'flex', alignItems: 'center' }}>
                <LocalPhoneOutlinedIcon sx={{ width: '36px', height: '36px', color: '#1D3176' }} />
                <Box>
                  <Typography
                    component='p'
                    sx={{
                      fontWeight: 500,
                      color: '#333333',
                      fontSize: { xs: '16px', md: '18px' },
                    }}
                  >
                    Телефон:
                  </Typography>
                  <a href='tel:+380442308739'>
                    +380442308739
                  </a>
                </Box>
              </Box>
            </Box>
            <Button
              component={Link}
              to='/contact'
              sx={{
                mx: 'auto',
                p: '8px 24px',
                color: '#FFFFFF',
                width: 'fit-content',
                textTransform: 'none',
                display: 'inline-block',
                backgroundColor: '#EB3036',
                fontSize: { xs: '14px', md: '20px' },
              }}
            >
              Звʼязатися з нами
            </Button>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default BarometerPage;
